<template>
  <div class="bind-box">
    <p class="title">
      <span class="email">{{ $t('bindEmail') }}</span>
    </p>
    <div id="bind-components">
      <bind-email class="position-center"></bind-email>
    </div>

  </div>
</template>

<script>
  import BindEmail from '../../bindEmail/Index.vue'
  import cookie from '../../../lib/cookie'
  import locales from './lang'

  export default {
    name: 'bind',
    components: {
      BindEmail
    },
    data: function () {
      return {
      }
    },
    locales,
    mounted() {
      if (cookie.getCookie('redirect_url')) {
        cookie.removeCookie('redirect_url')
      }
      // if (this.$route.query.reset_token) {
      //   this.bindPhone = false
      // }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
    border: 0;
  }

  .bind-box {
    width: 100%;
    border: 1px solid rgba(224,215,227,1);
    border-radius: 8px;
    @media screen and (max-width: 767px) {
      border-radius: 5px;
    }
  }

  .title {
    padding: 0 .16rem;
    border-bottom: .01rem solid rgba(224,215,227,1);
    line-height: .48rem;
    height: .48rem;
    display: block;
    span {
      line-height: .48rem;
      height: .48rem;
      border-bottom: .01rem solid transparent;
      color: #111;
      display: inline-block;
      font-size: .16rem;
    }
    @media screen and (max-width: 767px) {
      line-height: .44rem;
      height: .44rem;
      span {
        line-height: .44rem;
        height: .44rem;
        font-size: .14rem;
      }
    }
  }

  #bind-components {
    height: 4.9rem;
    display: table;
    width: 100%;
    max-width: 3rem;
    table-layout: fixed;
    margin: auto;
    div.position-center {
      display: table-cell;
      width: 100%;
      vertical-align: middle;
      text-align: center;
    }
    @media (max-width: 767px) {
      height: auto;
      padding-top: .4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?8a08c810